'use client';

import { __spreadArray, __awaiter, __generator } from '../../../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import { getSkills } from '../../../services/resumes/index.js';
import { useTranslate } from '../../../Contexts/translator/index.js';
import { useOnBoarding } from '../../context/index.js';
import Input from '../../../Input/index.js';
import Form from '../../../Form/index.js';
import SearchIcon from '../../../Images/SearchIcon/index.js';
import useDebounce from '../../../hooks/useDebounce.js';
import 'react-dom';
import '../../../hooks/useMakeSearchable/types.js';
import '../../../Utils/constants.js';
import '../../../services/resumes/types.js';
import { SEARCH_DELAY_TIME, CLICK_DELAY_TIME } from '../../const.js';
import Col from '../../../LayoutSystem/Col.js';
import Row from '../../../LayoutSystem/Row.js';
import { debounceHandler } from '../../../Utils/helpers.js';
import Tag from '../../../Tag/index.js';

var SkillField = function (_a) {
    var _b;
    var field = _a.field;
    var t = useTranslate().t;
    var _c = useOnBoarding(), baseMsUrl = _c.baseMsUrl, accessToken = _c.accessToken, lang = _c.lang;
    var _d = useState(''), inputValue = _d[0], setInputValue = _d[1];
    var _e = useState(), userSelectskills = _e[0], setUserSelectSkills = _e[1];
    var _f = useState(), suggetionSkills = _f[0], setSuggetionSkills = _f[1];
    var _g = useState(), recommendSkills = _g[0], setRecommendSkills = _g[1];
    var debounceValue = useDebounce(inputValue, SEARCH_DELAY_TIME);
    var getSuggetionSkills = function (searchKeyworks, limit) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedSkills, suggetionSkills_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    selectedSkills = userSelectskills === null || userSelectskills === void 0 ? void 0 : userSelectskills.map(function (skill) { return skill.name; });
                    return [4 /*yield*/, getSkills(baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', accessToken !== null && accessToken !== void 0 ? accessToken : '', searchKeyworks, selectedSkills, limit, lang)];
                case 1:
                    suggetionSkills_1 = _a.sent();
                    return [2 /*return*/, suggetionSkills_1];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getRecommendSkills = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var recommendSkills;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getSuggetionSkills(value)];
                case 1:
                    recommendSkills = _a.sent();
                    if (recommendSkills) {
                        setRecommendSkills(recommendSkills);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (debounceValue) {
            getRecommendSkills(debounceValue);
        }
    }, [debounceValue, userSelectskills]);
    useEffect(function () {
        var _a, _b;
        if (!((_a = field.watch) === null || _a === void 0 ? void 0 : _a.jobTitle))
            return;
        getSuggetionSkills((_b = field.watch) === null || _b === void 0 ? void 0 : _b.jobTitle, 5)
            .then(function (skills) {
            if (skills) {
                setSuggetionSkills(skills);
            }
        })
            .catch(function (error) { return console.error(error); });
    }, [(_b = field.watch) === null || _b === void 0 ? void 0 : _b.jobTitle, userSelectskills]);
    useEffect(function () {
        if (field.value && field.value.length > 0) {
            var userSelectedSkills = field.value.map(function (skill, index) {
                return {
                    id: index--,
                    name: skill.skillName
                };
            });
            setUserSelectSkills(userSelectedSkills);
        }
    }, [field.value]);
    return (React__default.createElement(Row, { gutter: [16, 24] },
        React__default.createElement(Col, null,
            React__default.createElement(Input, { type: 'text', value: inputValue, placeholder: t('Search'), clearValue: true, onChange: setInputValue, prefixIcon: React__default.createElement(SearchIcon, null), hasError: field.isError, onClickSuggestionItem: function (suggestion) {
                    var _a;
                    field.onChange(__spreadArray(__spreadArray([], ((_a = field.value) !== null && _a !== void 0 ? _a : []), true), [
                        {
                            skillName: suggestion.name,
                            skillLevel: 1
                        }
                    ], false));
                    setUserSelectSkills(__spreadArray(__spreadArray([], (userSelectskills !== null && userSelectskills !== void 0 ? userSelectskills : []), true), [suggestion], false));
                    setInputValue('');
                }, listRecommend: recommendSkills, searchNotFound: t('No Result Found') })),
        userSelectskills && userSelectskills.length > 0 ? (React__default.createElement(Col, null,
            React__default.createElement(Row, { gutter: 8 }, userSelectskills === null || userSelectskills === void 0 ? void 0 : userSelectskills.map(function (skill, index) {
                return (React__default.createElement(Col, { xs: 'auto', key: "".concat(skill.name, "_").concat(skill.id, "_").concat(index) },
                    React__default.createElement(Tag, { iconType: 'remove', label: skill.name, onClick: debounceHandler(function () {
                            var _a;
                            setUserSelectSkills(userSelectskills.filter(function (_, indexSkill) { return indexSkill !== index; }));
                            field.onChange((_a = field.value) === null || _a === void 0 ? void 0 : _a.filter(function (_, indexValue) { return indexValue !== index; }));
                        }, CLICK_DELAY_TIME), size: 'medium', isMobile: false })));
            })))) : null,
        suggetionSkills && suggetionSkills.length > 0 ? (React__default.createElement(Col, null,
            React__default.createElement(Form.Label, null, t('Suggested skills for you')),
            React__default.createElement(Row, { gutter: 8 }, suggetionSkills.map(function (skill) {
                return (React__default.createElement(Col, { xs: 'auto', key: "".concat(skill.name, "_").concat(skill.id) },
                    React__default.createElement(Tag, { iconType: 'add', label: skill.name, onClick: debounceHandler(function () {
                            setUserSelectSkills(__spreadArray(__spreadArray([], (userSelectskills !== null && userSelectskills !== void 0 ? userSelectskills : []), true), [skill], false));
                            // change field value when selected recommendSkill
                            field.onChange(__spreadArray(__spreadArray([], field.value, true), [
                                {
                                    skillName: skill.name,
                                    skillLevel: 1
                                }
                            ], false));
                        }, CLICK_DELAY_TIME), size: 'medium', isMobile: true })));
            })))) : null));
};

export { SkillField };
//# sourceMappingURL=SkillField.js.map
